import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface BalanceVisibilityContextType {
  isVisible: boolean;
  toggle: () => void;
  setIsVisible: (visible: boolean) => void;
}

const BalanceVisibilityContext = createContext<BalanceVisibilityContextType | undefined>(undefined);

export const BalanceVisibilityProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isVisible, setIsVisible] = useState<boolean>(() => {
    // Carregar preferência do localStorage, padrão é visível (true)
    const saved = localStorage.getItem('balance_visibility');
    return saved !== null ? saved === 'true' : true;
  });

  useEffect(() => {
    // Salvar preferência no localStorage sempre que mudar
    localStorage.setItem('balance_visibility', isVisible.toString());
  }, [isVisible]);

  const toggle = () => {
    setIsVisible((prev) => !prev);
  };

  return (
    <BalanceVisibilityContext.Provider value={{ isVisible, toggle, setIsVisible }}>
      {children}
    </BalanceVisibilityContext.Provider>
  );
};

export const useBalanceVisibility = () => {
  const context = useContext(BalanceVisibilityContext);
  if (context === undefined) {
    throw new Error('useBalanceVisibility must be used within a BalanceVisibilityProvider');
  }
  return context;
};

